import bitcoinCryptoImg from 'assets/images/bitcoinKrypto.png';
import bitcoinCryptoOverview from 'assets/images/booksOverview/bitcoinCrypto.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const bitcoinCrypto = {
  book: {
    id: 'bitcoin-krypto',
    format: FLIP_BOOKS,
    title: 'Bitcoin & crypto',
    subtitle: 'Hype or future',
    videos: 'Erwin W. Heri, Alexandra Janssen, Rino Borini, Patrick Eugster, Nicola Plain und Gérard Fischer',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 52, videos: 33 },
    price: [39, 49],
    introductions: ['Introduction Bitcoin and Crypto'],
    image: bitcoinCryptoImg,
    overviewImg: bitcoinCryptoOverview,
  },
  bookIds: [39, 40],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([39, 49], [40, 39]),
};

export default bitcoinCrypto;
